import Main from '@/views/common/main'
import permission from './permission' //系统管理
import risk from './risk' //盘口调度平台
import sync from './sync' //同步管理
import newpayment from './newpayment' //支付管理
import appdata from './appdata' //盘口数据
import appConfig from './appConfig' //app配置
import Report from './Report' //数据报表
import user from './user' //玩家管理
import riskReport from './riskOperat'
import log from './log' //运营后台日志
function routeListObject(list: any = []) {
    return list.reduce((res: any, cur: any) => {
        res[cur.path] = cur
        return res
    }, {})
}
export function renderParent(item: any) {
    return {
        path: item.classname,
        name: item.url,
        meta: {
            icon: item.icon,
            title: item.title
        },
        component: Main,
        children: []
    }
}
export const routerList = {
    ...routeListObject(appdata[0].children),
    ...routeListObject(newpayment[0].children),
    ...routeListObject(risk[0].children),
    ...routeListObject(sync[0].children),
    ...routeListObject(permission[0].children),
    ...routeListObject(appConfig[0].children),
    ...routeListObject(Report[0].children),
    ...routeListObject(user[0].children),
    ...routeListObject(riskReport[0].children),
    ...routeListObject(log[0].children)
}

export const routerInherent = [
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true
        },
        component: () => import('@/views/common/login/login.vue')
    },
    {
        path: '/',
        name: 'home',
        redirect: '/home',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [
            {
                path: '/home',
                name: 'home',
                meta: {
                    hideInMenu: true,
                    title: '首页',
                    notCache: true,
                    icon: 'md-home'
                },
                component: () => import('@/views/common/home')
            }
        ]
    },
    {
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/views/common/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/views/common/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true
        },
        component: () => import('@/views/common/error-page/404.vue')
    }
]
export const router = [...appdata, ...newpayment, ...risk, ...sync, ...permission, ...appConfig, ...Report, ...user, ...riskReport, ...log]
